import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Cookies from 'js-cookie';
import VModal from 'vue-js-modal';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import PerfectScrollbar from 'vue2-perfect-scrollbar';
import { VueReCaptcha } from "vue-recaptcha-v3";
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
import './assets/css/form.css';
import './assets/css/style.css';

require('@/store/subscriber');
require('@/plugins/axios');
require('@/plugins/nprogress');

Vue.config.productionTip = false;

Vue.use(VueSweetalert2);
Vue.use(VModal);
Vue.use(PerfectScrollbar);
Vue.use(VueReCaptcha, {
  siteKey: process.env.VUE_APP_RECAPTCHAV3_SITEKEY,
});

Vue.component('pagination', require('laravel-vue-pagination'));

global.jQuery = require('jquery');
window.$ = global.jQuery;

store.dispatch('auth/attempt', Cookies.get('token')).then(() => {
  store.dispatch('site/getSiteData').then(() => {
    new Vue({
      router,
      store,
      render: (h) => h(App),
    }).$mount('#app');
  });
});
